import React, { forwardRef } from 'react'

import Box, { type BoxProps } from '../box'

export type CircleProps = BoxProps & {
  size?: number
}

const Circle = forwardRef<HTMLElement, CircleProps>(
  ({ size = 32, ...rest }, ref) => (
    <Box
      ref={ref}
      width={size}
      height={size}
      borderRadius='pill'
      overflowX='hidden'
      overflowY='hidden'
      alignItems='center'
      justifyContent='center'
      {...rest}
    />
  )
)
Circle.displayName = 'Circle'

export default Circle
